<template>
  <ContainerBody>
    <div class="ui divider horizontal">Mnemônicos Contrato</div>
    <TreeList
      label="Lista de Mnemônicos"
      :listItems="listMnemonicos"
      @addTextModal="copiarMnemonico"
    />
    <div class="ui divider horizontal">Mnemônicos Locação Rápida</div>
    <TreeList
      label="Lista de Mnemônicos"
      :listItems="listMnemonicosLocRapida"
      @addTextModal="copiarMnemonico"
    />
    <div class="ui divider horizontal">Mnemônicos PDL</div>
    <TreeList
      label="Lista de Mnemônicos"
      :listItems="listMnemonicosPDL"
      @addTextModal="copiarMnemonico"
    />
    <div class="ui divider horizontal">Mnemônicos Endereço Instalação</div>
    <TreeList
      label="Lista de Mnemônicos"
      :listItems="listMnemonicosEnderecoInstalacao"
      @addTextModal="copiarMnemonico"
    />
    <div class="ui divider horizontal">Mnemônicos de Valores</div>
    <TreeList
      label="Lista de Mnemônicos"
      :listItems="listMnemonicosValores"
      @addTextModal="copiarMnemonico"
    />
    <div class="ui divider horizontal">Mnemônicos de Primeiro Serviço</div>
    <TreeList
      label="Lista de Mnemônicos"
      :listItems="listMnemonicosPrimeiroServico"
      @addTextModal="copiarMnemonico"
    />
    <div class="ui divider horizontal">Mnemônicos de Primeiro Tarifador</div>
    <TreeList
      label="Lista de Mnemônicos"
      :listItems="listMnemonicosPrimeiroTarifador"
      @addTextModal="copiarMnemonico"
    />
    <div class="ui divider horizontal">Mnemônicos de Tabela</div>
    <TreeList
      label="Lista de Mnemônicos"
      :listItems="listMnemonicosTabela"
      @addTextModal="copiarMnemonico"
    />
    <div class="ui divider horizontal">Converter mnemônico por extenso</div>
    <TreeList
      label="Lista de Mnemônicos"
      :listItems="listMnemonicosExtenso"
      @addTextModal="copiarMnemonico"
    />
    <div class="ui divider horizontal">Datas</div>
    <TreeList
      label="Lista de Mnemônicos"
      :listItems="listMnemonicosDatas"
      @addTextModal="copiarMnemonico"
    />
    <div class="ui divider horizontal">Cliente Centralizador</div>
    <TreeList
      label="Lista de Mnemônicos"
      :listItems="listMnemonicosClienteCentralizador"
      @addTextModal="copiarMnemonico"
    />
  </ContainerBody>
</template>
<script>
import ContainerBody from '@/components/ContainerBody.vue';
import api from '@/services/api';
import TreeList from '@/components/TreeList.vue';

export default {
  name: 'MnemonicosContrato',
  components: {
    ContainerBody,
    TreeList,
  },
  data() {
    return {
      listMnemonicos: [],
      listMnemonicosLocRapida: [
        {
          id: 1,
          name: 'Locação Rápida',
          placeholder: '',
          parent_id: 0,
          collection: 'locrapida',
        },
        {
          id: 2,
          name: 'Dias Locação Rápida',
          placeholder: 'diaslocacaorapida',
          parent_id: 1,
          collection: 'diaslocacaorapida',
          collectionPai: 'locrapida',
        },
        {
          id: 3,
          name: 'Data Início Locação Rápida',
          placeholder: 'datainiciolocacaorapida',
          parent_id: 1,
          collection: 'datainiciolocacaorapida',
          collectionPai: 'locrapida',
        },
        {
          id: 4,
          name: 'Data Fim Locação Rápida',
          placeholder: 'datafimlocacaorapida',
          parent_id: 1,
          collection: 'datafimlocacaorapida',
          collectionPai: 'locrapida',
        },
        {
          id: 5,
          name: 'Data vencimento Locação Rápida',
          placeholder: 'datavenctolocacaorapida',
          parent_id: 1,
          collection: 'datavenctolocacaorapida',
          collectionPai: 'locrapida',
        },
        {
          id: 6,
          name: 'Total Ativos Preço Sugerido Locação Rápida',
          placeholder: 'totalAtivosPrecoSugeridoLocacaoRapida',
          parent_id: 1,
          collection: 'totalAtivosPrecoSugeridoLocacaoRapida',
          collectionPai: 'locrapida',
        },
        {
          id: 7,
          name: 'Total Ativos Valor Reposição Locação Rápida',
          placeholder: 'totalAtivosValorReposicaoLocacaoRapida',
          parent_id: 1,
          collection: 'totalAtivosValorReposicaoLocacaoRapida',
          collectionPai: 'locrapida',
        },
        {
          id: 8,
          name: 'Total Locação Rápida',
          placeholder: 'totalLocacaoRapida',
          parent_id: 1,
          collection: 'totalLocacaoRapida',
          collectionPai: 'locrapida',
        },
        {
          id: 9,
          name: 'Total Locação Rápida X Quantidade',
          placeholder: 'totalLocacaoRapidaXQuantidade',
          parent_id: 1,
          collection: 'totalLocacaoRapidaXQuantidade',
          collectionPai: 'locrapida',
        },
        {
          id: 10,
          name: 'Total Locação Rápida Extenso',
          placeholder: 'totalLocacaoRapida_formatado_extenso_caixa_alta',
          parent_id: 1,
          collection: 'totalLocacaoRapida_formatado_extenso_caixa_alta',
          collectionPai: 'locrapida',
        },
        {
          id: 11,
          name: 'Total Ativos X Quantidade',
          placeholder: 'totalAtivosValorReposicaoLocacaoRapidaXQuantidade',
          parent_id: 1,
          collection: 'totalAtivosValorReposicaoLocacaoRapidaXQuantidade',
          collectionPai: 'locrapida',
        },
        {
          id: 12,
          name: 'Total Ativos X Quantidade Extenso',
          placeholder: 'totalAtivosValorReposicaoLocacaoRapidaXQuantidade_formatado_extenso_caixa_alta',
          parent_id: 1,
          collection: 'totalAtivosValorReposicaoLocacaoRapidaXQuantidade_formatado_extenso_caixa_alta',
          collectionPai: 'locrapida',
        },
        {
          id: 13,
          name: 'Condição de pagamento (Aba Locação Rápida)',
          placeholder: 'locacao_rapida_condicao',
          parent_id: 1,
          collection: 'locacao_rapida_condicao',
          collectionPai: 'locrapida',
        },
        {
          id: 14,
          name: 'Dias Locação Rápida Considera Dia Envio',
          placeholder: 'diaslocacaorapida_considera_dia_envio',
          parent_id: 1,
          collection: 'diaslocacaorapida_considera_dia_envio',
          collectionPai: 'locrapida',
        },
      ],
      listMnemonicosValores: [
        {
          id: 1,
          name: 'Valores',
          placeholder: '',
          parent_id: 0,
          collection: 'valores',
        },
        {
          id: 2,
          name: 'Total Produtos',
          placeholder: 'total_ctprod',
          parent_id: 1,
          collection: 'total_ctprod',
          collectionPai: 'valores',
        },
        {
          id: 4,
          name: 'Total Serviços',
          placeholder: 'total_servicos',
          parent_id: 1,
          collection: 'total_servicos',
          collectionPai: 'valores',
        },
        {
          id: 5,
          name: 'Total Serviços sem Tipo',
          placeholder: 'total_servicos_sem_tipo',
          parent_id: 1,
          collection: 'total_servicos_sem_tipo',
          collectionPai: 'valores',
        },
        {
          id: 6,
          name: 'Total Serviços + Produtos',
          placeholder: 'total_servicos_produtos',
          parent_id: 1,
          collection: 'total_servicos_produtos',
          collectionPai: 'valores',
        },
        {
          id: 7,
          name: 'Total Serviços sem tipo + Produtos',
          placeholder: 'total_servicos_sem_tipo_produtos',
          parent_id: 1,
          collection: 'total_servicos_sem_tipo_produtos',
          collectionPai: 'valores',
        },
      ],
      listMnemonicosPrimeiroServico: [
        {
          id: 1,
          name: 'Primeiro Serviço',
          placeholder: '',
          parent_id: 0,
          collection: 'primeiro_servico',
        },
        {
          id: 2,
          name: 'Tipo de Documento',
          placeholder: 'tipo_documento_primeiro_servico',
          parent_id: 1,
          collection: 'tipo_documento_primeiro_servico',
          collectionPai: 'primeiro_servico',
        },
        {
          id: 4,
          name: 'Data Vencimento',
          placeholder: 'data_vencimento_primeiro_servico',
          parent_id: 1,
          collection: 'data_vencimento_primeiro_servico',
          collectionPai: 'primeiro_servico',
        },
        {
          id: 5,
          name: 'Nome do Serviço',
          placeholder: 'descricao_primeiro_servico',
          parent_id: 1,
          collection: 'descricao_primeiro_servico',
          collectionPai: 'primeiro_servico',
        },
      ],
      listMnemonicosPrimeiroTarifador: [
        {
          id: 1,
          name: 'Primeiro Tarifador',
          placeholder: '',
          parent_id: 0,
          collection: 'primeiro_tarifador',
        },
        {
          id: 2,
          name: 'Tarifador',
          placeholder: 'tarifador',
          parent_id: 1,
          collection: 'tarifador',
          collectionPai: 'primeiro_tarifador',
        },
        {
          id: 4,
          name: 'Qtde. Franquia',
          placeholder: 'qtdefranquia',
          parent_id: 1,
          collection: 'qtdefranquia',
          collectionPai: 'primeiro_tarifador',
        },
        {
          id: 5,
          name: 'Valor Franquia',
          placeholder: 'valorfranquia',
          parent_id: 1,
          collection: 'valorfranquia',
          collectionPai: 'primeiro_tarifador',
        },
        {
          id: 6,
          name: 'Valor Excedente',
          placeholder: 'valorexcedente',
          parent_id: 1,
          collection: 'valorexcedente',
          collectionPai: 'primeiro_tarifador',
        },
        {
          id: 7,
          name: 'Descrição Tarifador',
          placeholder: 'descricao',
          parent_id: 1,
          collection: 'descricao',
          collectionPai: 'primeiro_tarifador',
        },
        {
          id: 8,
          name: 'Dias para vencimento franquia',
          placeholder: 'diasvenc',
          parent_id: 1,
          collection: 'diasvenc',
          collectionPai: 'primeiro_tarifador',
        },
        {
          id: 9,
          name: 'Dia fixo de vencimento franquia',
          placeholder: 'diavencto',
          parent_id: 1,
          collection: 'diavencto',
          collectionPai: 'primeiro_tarifador',
        },
        {
          id: 10,
          name: 'Dias para vencimento excedente',
          placeholder: 'diasvence',
          parent_id: 1,
          collection: 'diasvence',
          collectionPai: 'primeiro_tarifador',
        },
        {
          id: 11,
          name: 'Dia fixo de vencimento excedente',
          placeholder: 'diavenctoexced',
          parent_id: 1,
          collection: 'diavenctoexced',
          collectionPai: 'primeiro_tarifador',
        },
      ],
      listMnemonicosEnderecoInstalacao: [
        {
          id: 1,
          name: 'Endereço de Instalação',
          placeholder: '',
          parent_id: 0,
          collection: 'endereco_instalacao',
        },
        {
          id: 2,
          name: 'Logradouro',
          placeholder: 'endereco_instalacao',
          parent_id: 1,
          collection: 'endereco_instalacao',
          collectionPai: 'endereco_instalacao',
        },
        {
          id: 3,
          name: 'Número',
          placeholder: 'endereco_instalacao_numero',
          parent_id: 1,
          collection: 'endereco_instalacao_numero',
          collectionPai: 'endereco_instalacao',
        },
        {
          id: 4,
          name: 'Complemento',
          placeholder: 'endereco_instalacao_complemento',
          parent_id: 1,
          collection: 'endereco_instalacao_complemento',
          collectionPai: 'endereco_instalacao',
        },
        {
          id: 5,
          name: 'Bairro',
          placeholder: 'endereco_instalacao_bairro',
          parent_id: 1,
          collection: 'endereco_instalacao_bairro',
          collectionPai: 'endereco_instalacao',
        },
        {
          id: 6,
          name: 'Município',
          placeholder: 'endereco_instalacao_municipio',
          parent_id: 1,
          collection: 'endereco_instalacao_municipio',
          collectionPai: 'endereco_instalacao',
        },
        {
          id: 7,
          name: 'UF',
          placeholder: 'endereco_instalacao_uf',
          parent_id: 1,
          collection: 'endereco_instalacao_uf',
          collectionPai: 'endereco_instalacao',
        },
        {
          id: 8,
          name: 'CEP',
          placeholder: 'endereco_instalacao_cep',
          parent_id: 1,
          collection: 'endereco_instalacao_cep',
          collectionPai: 'endereco_instalacao',
        },
        {
          id: 9,
          name: 'Razão Social',
          placeholder: 'endereco_instalacao_razao_social',
          parent_id: 1,
          collection: 'endereco_instalacao_razao_social',
          collectionPai: 'endereco_instalacao',
        },
        {
          id: 10,
          name: 'Nome Fantasia',
          placeholder: 'endereco_instalacao_nome_fantasia',
          parent_id: 1,
          collection: 'endereco_instalacao_nome_fantasia',
          collectionPai: 'endereco_instalacao',
        },
        {
          id: 11,
          name: 'CNPJ',
          placeholder: 'endereco_instalacao_cnpj',
          parent_id: 1,
          collection: 'endereco_instalacao_cnpj',
          collectionPai: 'endereco_instalacao',
        },
        {
          id: 12,
          name: 'Contato',
          placeholder: 'endereco_instalacao_contato',
          parent_id: 1,
          collection: 'endereco_instalacao_contato',
          collectionPai: 'endereco_instalacao',
        },
        {
          id: 13,
          name: 'Telefone',
          placeholder: 'endereco_instalacao_telefone',
          parent_id: 1,
          collection: 'endereco_instalacao_telefone',
          collectionPai: 'endereco_instalacao',
        },
        {
          id: 14,
          name: 'Nome do local',
          placeholder: 'endereco_instalacao_nome_do_local',
          parent_id: 1,
          collection: 'endereco_instalacao_nome_do_local',
          collectionPai: 'endereco_instalacao',
        },
      ],
      listMnemonicosTabela: [
        {
          id: 1,
          name: 'Tabelas',
          placeholder: '',
          parent_id: 0,
          collection: 'tabelas',
        },
        {
          id: 2,
          name: 'Tabela Serviços',
          placeholder: 'SERVICOS_TABELA_COMPLETA_NOVO',
          parent_id: 1,
          collection: 'tabelas',
          collectionPai: 'tabelas',
        },
        {
          id: 3,
          name: 'Tabela Produtos Tipo T',
          placeholder: 'PRODUTOS_TIPOT_TABELA_NOVO',
          parent_id: 1,
          collection: 'tabelas',
          collectionPai: 'tabelas',
        },
        {
          id: 4,
          name: 'Tabela Produtos do Contrato',
          placeholder: 'PRODUTOS_CTPROD_TABELA_NOVO',
          parent_id: 1,
          collection: 'tabelas',
          collectionPai: 'tabelas',
        },
        {
          id: 5,
          name: 'Tabela Locação Rápida',
          placeholder: 'LOCACAO_RAPIDA_NOVO',
          parent_id: 1,
          collection: 'tabelas',
          collectionPai: 'tabelas',
        },
        {
          id: 6,
          name: 'Tabela Produtos Tipo A',
          placeholder: 'LOCACAO_TIPO_A_EQUIPAMENTOS_NOVO',
          parent_id: 1,
          collection: 'tabelas',
          collectionPai: 'tabelas',
        },
        {
          id: 7,
          name: 'Tabela Pagamentos Fixos',
          placeholder: 'PAGAMENTOS_FIXOS_NOVO',
          parent_id: 1,
          collection: 'tabelas',
          collectionPai: 'tabelas',
        },
        {
          id: 8,
          name: 'Tabela PDL',
          placeholder: 'PDL_PRODUTOS',
          parent_id: 1,
          collection: 'tabelas',
          collectionPai: 'tabelas',
        },
        {
          id: 9,
          name: 'Tabela Representante Legal Filial',
          placeholder: 'REPRESENTANTE_LEGAL_FILIAL',
          parent_id: 1,
          collection: 'tabelas',
          collectionPai: 'tabelas',
        },
        {
          id: 10,
          name: 'Tabela Representante Legal Cliente',
          placeholder: 'REPRESENTANTE_LEGAL_CLIENTE',
          parent_id: 1,
          collection: 'tabelas',
          collectionPai: 'tabelas',
        },
        {
          id: 11,
          name: 'Tabela Contatos',
          placeholder: 'CONTATOS',
          parent_id: 1,
          collection: 'tabelas',
          collectionPai: 'tabelas',
        },
        {
          id: 12,
          name: 'Tabela Tarifadores',
          placeholder: 'TARIFADORES',
          parent_id: 1,
          collection: 'tabelas',
          collectionPai: 'tabelas',
        },
        {
          id: 13,
          name: 'Datas do contrato',
          placeholder: 'IMP_DATAS_CONTRATO',
          parent_id: 1,
          collection: 'tabelas',
          collectionPai: 'tabelas',
        },
      ],
      listMnemonicosExtenso: [
        {
          id: 1,
          name: 'Valores por Extenso',
          placeholder: '',
          parent_id: 0,
          collection: 'extenso',
          collectionPai: 'tabelas',
        },
        {
          id: 2,
          name: 'Valor por Extenso (Com unidade de valores)',
          placeholder: '_formatado_extenso_caixa_baixa',
          parent_id: 1,
          collection: 'extenso',
          collectionPai: 'tabelas',
        },
        {
          id: 3,
          name: 'Valor por Extenso (Sem unidade de valores)',
          placeholder: '_formatado_extenso_caixa_baixa_valor',
          parent_id: 1,
          collection: 'tabelas',
          collectionPai: 'tabelas',
        },
      ],
      listMnemonicosDatas: [
        {
          id: 1,
          name: 'Datas do contrato (Meses ou Dias)',
          placeholder: '',
          parent_id: 0,
          collection: 'datas',
          collectionPai: 'tabelas',
        },
        {
          id: 2,
          name: 'Dias do contrato com base na vigência',
          placeholder: 'dias',
          parent_id: 1,
          collection: 'tabelas',
          collectionPai: 'tabelas',
        },
        {
          id: 3,
          name: 'Dias do contrato com base na vigência (Extenso)',
          placeholder: 'dias_extenso',
          parent_id: 1,
          collection: 'dias_extenso',
          collectionPai: 'tabelas',
        },
        {
          id: 4,
          name: 'Meses do contrato com base na vigência',
          placeholder: 'meses',
          parent_id: 1,
          collection: 'meses',
          collectionPai: 'tabelas',
        },
        {
          id: 5,
          name: 'Meses do contrato com base na vigência (Extenso)',
          placeholder: 'meses_extenso',
          parent_id: 1,
          collection: 'meses_extenso',
          collectionPai: 'tabelas',
        },
        {
          id: 6,
          name: 'Dias do contrato com base na vigência (Extenso)',
          placeholder: 'dias_extenso_caixa_alta',
          parent_id: 1,
          collection: 'dias_extenso_caixa_alta',
          collectionPai: 'tabelas',
        },
      ],
      listMnemonicosPDL: [
        {
          id: 1,
          name: 'PDL',
          placeholder: '',
          parent_id: 0,
          collection: 'pdl',
        },
        {
          id: 2,
          name: 'Total',
          placeholder: 'pdl_total',
          parent_id: 1,
          collection: 'pdl_total',
          collectionPai: 'pdl',
        },
        {
          id: 3,
          name: 'Tipo Frete',
          placeholder: 'pdl_tipo_frete',
          parent_id: 1,
          collection: 'pdl_tipo_frete',
          collectionPai: 'pd',
        },
        {
          id: 4,
          name: 'Valor Frete',
          placeholder: 'pdl_frete',
          parent_id: 1,
          collection: 'pdl_frete',
          collectionPai: 'pdl',
        },
        {
          id: 5,
          name: 'Tipo Operação',
          placeholder: 'pdl_tipo_operacao',
          parent_id: 1,
          collection: 'pdl_tipo_operacao',
          collectionPai: 'pdl',
        },
        {
          id: 6,
          name: 'Total de Indenização',
          placeholder: 'pdl_total_indenizacao',
          parent_id: 1,
          collection: 'pdl_total_indenizacao',
          collectionPai: 'pdl',
        },
        {
          id: 7,
          name: 'Data Início',
          placeholder: 'pdl_data_inicio',
          parent_id: 1,
          collection: 'pdl_data_inicio',
          collectionPai: 'pdl',
        },
        {
          id: 8,
          name: 'Data Fim',
          placeholder: 'pdl_data_fim',
          parent_id: 1,
          collection: 'pdl_data_fim',
          collectionPai: 'pdl',
        },
        {
          id: 9,
          name: 'Data Promissoria',
          placeholder: 'pdl_data_promissoria',
          parent_id: 1,
          collection: 'pdl_data_promissoria',
          collectionPai: 'pdl',
        },
        {
          id: 10,
          name: 'Observação',
          placeholder: 'pdl_observacao',
          parent_id: 1,
          collection: 'pdl_observacao',
          collectionPai: 'pdl',
        },
        {
          id: 11,
          name: 'Total do Pdl sem Frete',
          placeholder: '',
          parent_id: 1,
          collection: 'pdl_total_sem_frete',
          collectionPai: 'pdl',
        },
        {
          id: 12,
          name: 'Endereço de Instalação',
          placeholder: '',
          parent_id: 1,
          collection: 'pdl_end_instalacao',
          collectionPai: 'pdl',
        },
        {
          id: 13,
          name: 'localcadastro',
          placeholder: 'localcadastro',
          parent_id: 12,
          collection: 'localcadastro',
          collectionPai: 'pdl_end_instalacao',
        },
        {
          id: 14,
          name: 'endereco',
          placeholder: 'endereco',
          parent_id: 12,
          collection: 'endereco',
          collectionPai: 'pdl_end_instalacao',
        },
        {
          id: 15,
          name: 'bairro',
          placeholder: 'bairro',
          parent_id: 12,
          collection: 'bairro',
          collectionPai: 'pdl_end_instalacao',
        },
        {
          id: 16,
          name: 'municipio',
          placeholder: 'municipio',
          parent_id: 12,
          collection: 'municipio',
          collectionPai: 'pdl_end_instalacao',
        },
        {
          id: 17,
          name: 'uf',
          placeholder: 'uf',
          parent_id: 12,
          collection: 'uf',
          collectionPai: 'pdl_end_instalacao',
        },
        {
          id: 18,
          name: 'cep',
          placeholder: 'cep',
          parent_id: 12,
          collection: 'cep',
          collectionPai: 'pdl_end_instalacao',
        },
        {
          id: 19,
          name: 'numero',
          placeholder: 'numero',
          parent_id: 12,
          collection: 'numero',
          collectionPai: 'pdl_end_instalacao',
        },
        {
          id: 20,
          name: 'complemento',
          placeholder: 'complemento',
          parent_id: 12,
          collection: 'complemento',
          collectionPai: 'pdl_end_instalacao',
        },
      ],
      listMnemonicosClienteCentralizador: [
        {
          id: 1,
          name: 'Cliente Centralizador',
          placeholder: '',
          parent_id: 0,
          collection: 'cliente_centralizador',
        },
        {
          id: 2,
          name: 'Código',
          placeholder: 'codigo',
          parent_id: 1,
          collection: 'codigo',
          collectionPai: 'cliente_centralizador',
        },
        {
          id: 3,
          name: 'Razão Social',
          placeholder: 'razaosocial',
          parent_id: 1,
          collection: 'razaosocial',
          collectionPai: 'cliente_centralizador',
        },
        {
          id: 4,
          name: 'Nome Fantasia',
          placeholder: 'nomefantasia',
          parent_id: 1,
          collection: 'nomefantasia',
          collectionPai: 'cliente_centralizador',
        },
        {
          id: 5,
          name: 'CNPJ',
          placeholder: 'cnpj',
          parent_id: 1,
          collection: 'cnpj',
          collectionPai: 'cliente_centralizador',
        },
        {
          id: 6,
          name: 'Inscrição Estadual',
          placeholder: 'inscestadual',
          parent_id: 1,
          collection: 'inscestadual',
          collectionPai: 'cliente_centralizador',
        },
        {
          id: 7,
          name: 'Inscrição Municipal',
          placeholder: 'inscmunicipal',
          parent_id: 1,
          collection: 'inscmunicipal',
          collectionPai: 'cliente_centralizador',
        },
        {
          id: 8,
          name: 'Endereço',
          placeholder: 'endereco',
          parent_id: 1,
          collection: 'endereco',
          collectionPai: 'cliente_centralizador',
        },
        {
          id: 9,
          name: 'Número',
          placeholder: 'numero',
          parent_id: 1,
          collection: 'numero',
          collectionPai: 'cliente_centralizador',
        },
        {
          id: 10,
          name: 'Complemento',
          placeholder: 'complemento',
          parent_id: 1,
          collection: 'complemento',
          collectionPai: 'cliente_centralizador',
        },
        {
          id: 11,
          name: 'Bairro',
          placeholder: 'bairro',
          parent_id: 1,
          collection: 'bairro',
          collectionPai: 'cliente_centralizador',
        },
        {
          id: 12,
          name: 'Município',
          placeholder: 'municipio',
          parent_id: 1,
          collection: 'municipio',
          collectionPai: 'cliente_centralizador',
        },
        {
          id: 13,
          name: 'UF',
          placeholder: 'uf',
          parent_id: 1,
          collection: 'uf',
          collectionPai: 'cliente_centralizador',
        },
        {
          id: 14,
          name: 'CEP',
          placeholder: 'cep',
          parent_id: 1,
          collection: 'cep',
          collectionPai: 'cliente_centralizador',
        },
        {
          id: 15,
          name: 'Telefone',
          placeholder: 'telefone',
          parent_id: 1,
          collection: 'telefone',
          collectionPai: 'cliente_centralizador',
        },
        {
          id: 16,
          name: 'Celular',
          placeholder: 'celular',
          parent_id: 1,
          collection: 'celular',
          collectionPai: 'cliente_centralizador',
        },
        {
          id: 17,
          name: 'E-mail',
          placeholder: 'email',
          parent_id: 1,
          collection: 'email',
          collectionPai: 'cliente_centralizador',
        },
        {
          id: 18,
          name: 'E-mail Cobrança',
          placeholder: 'emailcobranca',
          parent_id: 1,
          collection: 'emailcobranca',
          collectionPai: 'cliente_centralizador',
        },
      ],
    };
  },
  async created() {
    await api.get('api/contratos/mnemonicos').then(result => {
      this.listMnemonicos = result.data;
    });
  },
  methods: {
    copiarMnemonico(placeholder) {
      if (placeholder.parent_id > 0 && placeholder.collectionPai && placeholder.placeholder != '') {
        let nome = placeholder.name;
        const somentePlaceHolder = [
          'locrapida',
          'tabelas',
          'pdl',
          'endereco_instalacao',
          'valores',
          'primeiro_servico',
          'listas',
          'primeiro_tarifador',
          'endereco_faturamento',
          'endereco_cobranca',
          'cliente_centralizador',
        ];
        if (somentePlaceHolder.includes(placeholder.collectionPai)) {
          nome = placeholder.placeholder;
        }
        somentePlaceHolder.push('contrato');
        let mnemonico = '${';
        if (!somentePlaceHolder.includes(placeholder.collectionPai)) {
          mnemonico += `entidade_${placeholder.collectionPai}.`;
        }
        if (placeholder.collectionPai == 'pdl_end_instalacao') {
          mnemonico += 'pdl_end_instalacao.';
        }
        if (placeholder.collectionPai == 'endereco_faturamento') {
          mnemonico += 'endereco_faturamento_';
        }
        if (placeholder.collectionPai == 'endereco_cobranca') {
          mnemonico += 'endereco_cobranca_';
        }
        if (placeholder.collectionPai == 'cliente_centralizador') {
          mnemonico += 'entidade_cliente_centralizador_';
        }
        mnemonico += `${nome}}`;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(mnemonico).then(() => {
            this.$alertify.success('Copiado com Sucesso!!');
          });
        } else {
          this.$alertify.success('Erro ao Copiar');
        }
      }
    },
  },
};
</script>
